import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import { withStyles, useMediaQuery } from '@material-ui/core';
import { Dialog, Button, Icon, Span } from 'components/Ui';
import { domainMap } from 'containers/Landing/constants';

import MUIStyles from './styles';
import styles from './styles.scss';

const BrandSwitchDialog = ({
  onStay,
  onContinue,
  open,
  classes,
  servicedByBrand,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const regionalBrand = domainMap[window.redirectBrand].name;
  return (
    <Dialog
      open={open}
      classes={classes}
      size="small"
      fullScreen={isMobile}
      isCloseIcon={false}
      disableBackdropClick
      disableKeyboard
    >
      <div className={styles.container}>
        <Icon icon="exclamation-triangle" className={styles.warningIcon} />
        <Span className={styles.title}>Are you looking for another brand?</Span>
        <div className={styles.text}>
          <p>
            <Span>
              You appear to be coming from a ZIP Code that is not serviced by
            </Span>{' '}
            {servicedByBrand}.{' '}
            <Span>Your area is serviced by our regional brand</Span>{' '}
            {regionalBrand}.
          </p>
          <p>
            <Span>
              {
                'Click "stay here" to stay on this brand or click "continue" to continue your experience on your area\'s regional brand site.'
              }
            </Span>
          </p>
        </div>
        <div className={styles.buttonsContainer}>
          <Button className={styles.btn} onClick={onStay} text="Stay Here" />
          <Button className={styles.btn} onClick={onContinue} text="Continue" />
        </div>
      </div>
    </Dialog>
  );
};

BrandSwitchDialog.propTypes = {
  onStay: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  classes: PropTypes.object,
  servicedByBrand: PropTypes.string,
};

export default withStyles(MUIStyles, { withTheme: true })(BrandSwitchDialog);
